module.exports = __webpack_public_path__ + "img/coupon-icon-3.fcfc9b11.png";